import {Navigate} from 'react-router-dom'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../parts/crud/List'
import {ColumnType} from '../../../parts/crud/Types'

export const ListExtctractor = () => {
  const columns: Array<ColumnType> = [
    {
      title: 'Nome',
      key: 'name',
      type: 'text',
      orderable: true,
    },
    {
      title: 'GUID',
      key: 'codename',
      type: 'text',
      orderable: true,
    },
    {
      title: 'Server gestiti',
      key: 'server_count',
      type: 'text',
      orderable: true,
    },
    {
      title: 'Clienti gestiti',
      key: 'tenant_count',
      type: 'text',
      orderable: false,
    },
    {
      title: 'Eventi nelle ultime 24h',
      key: 'events_24h',
      type: 'text',
      orderable: false,
    },
    {
      title: 'Tempo di loop (sec)',
      key: 'roundtrip_time',
      type: 'text',
      orderable: true,
    },
    {
      title: 'Ping (sec)',
      key: 'ping_time',
      type: 'text',
      orderable: true,
    },
  ]
  return (
    <>
      <CrudProvider api='extractors'>
        <ListComponent
          defOrder='name'
          defOrderDir='asc'
          columns={columns}
          title_delete='Eliminazione estrattore'
          text_eliminare="Sei sicuro di voler eliminare questo estrattore? L'operazione non è reversibile"
          text_eliminato='Estrattore eliminato con successo'
          text_nuovo='Nuovo estrattore'
        ></ListComponent>
      </CrudProvider>
    </>
  )
}
